import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading, ErrorState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { User } from "lucide-react";

const ROWS = [
  ["Provider code", "provider_code"], ["Name", "name"], ["Type", "provider_type"], ["Mobile", "mobile"], ["Email", "email"],
  ["City", "city"], ["Nature of service", "nature_of_service"], ["PAN", "pan"], ["GSTIN", "gstin"],
  ["Bank account name", "bank_account_name"], ["Bank account", "bank_account"], ["IFSC", "ifsc"],
];

export default function ProviderProfile() {
  const { data, isLoading, isError, refetch } = useQuery({ queryKey: ["spMe"], queryFn: async () => (await api.get("/sp/me")).data });
  if (isLoading) return <Loading />;
  if (isError) return <ErrorState onRetry={refetch} />;
  const p = data.profile;
  return (
    <div>
      <PageHeader overline="Service Provider" title="My Profile" icon={User} subtitle="To correct any detail, contact IntenCiv at contact@intenciv.in or +91 73990 00299." />
      <Card className="border-slate-200 shadow-none divide-y">
        {ROWS.map(([label, key]) => (
          <div key={key} className="flex px-4 py-3 text-sm">
            <span className="w-44 text-slate-500 shrink-0">{label}</span>
            <span className="text-navy">{key === "gstin" && !p.gst_registered ? "Not registered" : p[key] || "—"}</span>
          </div>
        ))}
      </Card>
    </div>
  );
}
